import { t } from 'i18next';
import { TableInstance } from 'react-table';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';
import { CustomersTableCustomerFragment } from './__generated__/CustomersTable.graphql';

export function CustomersTablePagination({
  table,
}: {
  table: TableInstance<CustomersTableCustomerFragment>;
}) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function CustomersTablePageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<CustomersTableCustomerFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label={t('customersPerPage')}
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
